<div class="container-fluid">
  <div class="kpi-list py-3">
    <div class="kpi-col">
      <app-kpi
        [title]="'DASHBOARD_LBL_KPI_LEADS_COUNT' | translate"
        kpiData="{{ leadCount$ | async }}"
      />
    </div>
    @let conversionRate = this.conversionRate$ | async;
    <div class="kpi-col">
      <app-kpi
        [title]="'DASHBOARD_LBL_KPI_CONVERSION_RATE' | translate"
        kpiData="{{ (conversionRate | number : '1.0-2' : 'fr') + '%' }}"
      />
    </div>
    <div class="kpi-col">
      <ng-container>
        <app-kpi
          [title]="'DASHBOARD_LBL_KPI_RAW_CONTRACTS_COUNT' | translate"
          kpiData="{{ rawContractCount$ | async }}"
        />
      </ng-container>
    </div>
    <div class="kpi-col">
      <app-kpi
        [title]="'DASHBOARD_LBL_KPI_VALIDATED_CONTRACTS_COUNT' | translate"
        kpiData="{{ validatedContractCount$ | async }}"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-xl-6 pb-3">
      <div class="card data-card">
        <div class="card-chart-body">
          <div class="card-chart-content">
            <h6 class="card-title" translate>
              DASHBOARD_LBL_CHART_LEADS_BY_SOURCES
              <i
                class="mdi mdi-information-outline"
                placement="bottom"
                [ngbTooltip]="'DASHBOARD_TOOLTIP_LEADS_BY_SOURCE' | translate"
              ></i>
            </h6>
            <div class="card-chart">
              <canvas
                id="leadBySourceChart"
                style="display: block; box-sizing: border-box; height: 248px"
              >
                <!--                                     style="display: block; box-sizing: border-box; height: 248px; width: 768px;">-->
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-6 pb-3">
      <div class="card data-card">
        <div class="card-chart-body">
          <div class="card-chart-content">
            <h6 class="card-title" translate>
              DASHBOARD_LBL_CHART_RAW_CONTRACTS_BY_SOURCES
              <i
                class="mdi mdi-information-outline"
                placement="bottom"
                [ngbTooltip]="
                  'DASHBOARD_TOOLTIP_CONTRACTS_BY_SOURCE' | translate
                "
              ></i>
            </h6>
            <div class="card-chart">
              <canvas
                id="contractsBySourceChart"
                style="
                  display: block;
                  box-sizing: border-box;
                  height: 248px;
                  width: 768px;
                "
              ></canvas>
              <!--              style="display: block; box-sizing: border-box; height: 248px; width: 768px;"-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-6 pb-3">
      <div class="card data-card">
        <div class="card-chart-body">
          <div class="card-chart-content">
            <h6 class="card-title" translate>
              DASHBOARD_LBL_CHART_LEADS_BY_PRODUCT_CATEGORY
              <i
                class="mdi mdi-information-outline"
                placement="bottom"
                [ngbTooltip]="
                  'DASHBOARD_TOOLTIP_LEADS_BY_PRODUCT_CATEGORY' | translate
                "
              ></i>
            </h6>
            <div class="card-chart">
              <canvas
                id="leadByProductCategoryChart"
                style="display: block; box-sizing: border-box; height: 248px"
              >
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-6 pb-3">
      <div class="card data-card">
        <div class="card-chart-body">
          <div class="card-chart-content">
            <h6 class="card-title" translate>
              DASHBOARD_LBL_CHART_RAW_CONTRACT_BY_PRODUCT_CATEGORY
              <i
                class="mdi mdi-information-outline"
                placement="bottom"
                [ngbTooltip]="
                  'DASHBOARD_TOOLTIP_CONTRACTS_BY_PRODUCT_CATEGORY' | translate
                "
              ></i>
            </h6>
            <div class="card-chart">
              <canvas
                id="contractsByProductCategoryChart"
                style="
                  display: block;
                  box-sizing: border-box;
                  height: 248px;
                  width: 768px;
                "
              ></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-6 pb-3">
      <div class="card data-card">
        <div class="card-chart-body">
          <div class="card-chart-content">
            <h6 class="card-title" translate>
              DASHBOARD_LBL_CHART_LEADS_BY_SALESPERSON
              <i
                class="mdi mdi-information-outline"
                placement="bottom"
                [ngbTooltip]="
                  'DASHBOARD_TOOLTIP_LEADS_BY_SALES_PERSON' | translate
                "
              ></i>
            </h6>
            <div class="card-chart">
              <canvas
                id="leadBySalesPersonChart"
                style="display: block; box-sizing: border-box; height: 248px"
              >
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-6 pb-3">
      <div class="card data-card">
        <div class="card-chart-body">
          <div class="card-chart-content">
            <h6 class="card-title" translate>
              DASHBOARD_LBL_CHART_RAW_CONTRACTS_BY_SALESPERSON
              <i
                class="mdi mdi-information-outline"
                placement="bottom"
                [ngbTooltip]="
                  'DASHBOARD_TOOLTIP_CONTRACTS_BY_SALES_PERSON' | translate
                "
              ></i>
            </h6>
            <div class="card-chart">
              <canvas
                id="contractsBySalesPersonChart"
                style="
                  display: block;
                  box-sizing: border-box;
                  height: 248px;
                  width: 768px;
                "
              ></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
